/**
 * Suggerimenti del giorno - Validati scientificamente
 * Ogni suggerimento include riferimento in formato APA.
 * 60 suggerimenti = ~2 mesi senza ripetizioni.
 */

const DAILY_TIPS = [
  // ===== ORGANIZZAZIONE E PRODUTTIVITÀ =====
  {
    id: 1,
    category: "Organizzazione",
    text: "Inizia la giornata con il compito più difficile: le risorse cognitive sono al massimo al mattino.",
    reference: "Baumeister, R. F., Bratslavsky, E., Muraven, M., & Tice, D. M. (1998). Ego depletion: Is the active self a limited resource? Journal of Personality and Social Psychology, 74(5), 1252\u20131265."
  },
  {
    id: 2,
    category: "Organizzazione",
    text: "Spezza i grandi obiettivi in micro-azioni concrete: obiettivi specifici e raggiungibili aumentano la motivazione.",
    reference: "Locke, E. A., & Latham, G. P. (2002). Building a practically useful theory of goal setting and task motivation. American Psychologist, 57(9), 705\u2013717."
  },
  {
    id: 3,
    category: "Organizzazione",
    text: "Scrivi le cose da fare: liberare la mente riduce l\u2019ansia.",
    reference: "Zeigarnik, B. (1927). Das Behalten erledigter und unerledigter Handlungen. Psychologische Forschung, 9, 1\u201385."
  },
  {
    id: 4,
    category: "Organizzazione",
    text: "Pianifica domani stasera: dormire su un piano riduce il rimuginio.",
    reference: "Scullin, M. K., Krueger, M. L., Ballard, H. K., Pruett, N., & Bliwise, D. L. (2018). The effects of bedtime writing on difficulty falling asleep. Journal of Experimental Psychology: General, 147(1), 139\u2013146."
  },
  {
    id: 5,
    category: "Organizzazione",
    text: "Usa la regola dei 2 minuti: se puoi farlo subito, fallo ora.",
    reference: "Allen, D. (2001). Getting Things Done: The Art of Stress-Free Productivity. Penguin Books."
  },
  {
    id: 6,
    category: "Organizzazione",
    text: "Fai una sola cosa alla volta: il multitasking riduce la produttivit\u00e0 fino al 40%.",
    reference: "Rubinstein, J. S., Meyer, D. E., & Evans, J. E. (2001). Executive control of cognitive processes in task switching. Journal of Experimental Psychology: Human Perception and Performance, 27(4), 763\u2013797."
  },
  {
    id: 7,
    category: "Organizzazione",
    text: "Fai pause regolari: il cervello lavora meglio con cicli di concentrazione e riposo.",
    reference: "Ariga, A., & Lleras, A. (2011). Brief and rare mental \u2018breaks\u2019 keep you focused: Deactivation and reactivation of task goals preempt vigilance decrements. Cognition, 118(3), 439\u2013443."
  },
  {
    id: 8,
    category: "Organizzazione",
    text: "Imposta scadenze anche per i compiti senza urgenza: le deadline riducono la procrastinazione.",
    reference: "Ariely, D., & Wertenbroch, K. (2002). Procrastination, deadlines, and performance: Self-control by precommitment. Psychological Science, 13(3), 219\u2013224."
  },

  // ===== BENESSERE EMOTIVO =====
  {
    id: 9,
    category: "Benessere emotivo",
    text: "Nomina le tue emozioni: dare un nome a ci\u00f2 che senti ne riduce l\u2019intensit\u00e0.",
    reference: "Lieberman, M. D., Eisenberger, N. I., Crockett, M. J., Tom, S. M., Pfeifer, J. H., & Way, B. M. (2007). Putting feelings into words: Affect labeling disrupts amygdala activity in response to affective stimuli. Psychological Science, 18(5), 421\u2013428."
  },
  {
    id: 10,
    category: "Benessere emotivo",
    text: "Scrivi 3 cose positive della giornata: allena il cervello a notare il bene.",
    reference: "Seligman, M. E. P., Steen, T. A., Park, N., & Peterson, C. (2005). Positive psychology progress: Empirical validation of interventions. American Psychologist, 60(5), 410\u2013421."
  },
  {
    id: 11,
    category: "Benessere emotivo",
    text: "5 minuti di respirazione lenta attivano il sistema nervoso parasimpatico.",
    reference: "Zaccaro, A., Piarulli, A., Laurino, M., Garbella, E., Menicucci, D., Neri, B., & Gemignani, A. (2018). How breath-control can change your life: A systematic review on psycho-physiological correlates of slow breathing. Frontiers in Human Neuroscience, 12, 353."
  },
  {
    id: 12,
    category: "Benessere emotivo",
    text: "Nota i tuoi pensieri senza giudicarli: \u00e8 il primo passo della mindfulness.",
    reference: "Khoury, B., Lecomte, T., Fortin, G., Masse, M., Therien, P., Bouchard, V., ... & Hofmann, S. G. (2013). Mindfulness-based therapy: A comprehensive meta-analysis. Clinical Psychology Review, 33(6), 763\u2013771."
  },
  {
    id: 13,
    category: "Benessere emotivo",
    text: "L\u2019umore influenza le decisioni: registralo per capire i tuoi pattern.",
    reference: "Schwarz, N., & Clore, G. L. (1983). Mood, misattribution, and judgments of well-being: Informative and directive functions of affective states. Journal of Personality and Social Psychology, 45(3), 513\u2013523."
  },
  {
    id: 14,
    category: "Benessere emotivo",
    text: "Pratica l\u2019auto-compassione: trattati come tratteresti un caro amico.",
    reference: "Neff, K. D. (2003). The development and validation of a scale to measure self-compassion. Self and Identity, 2(3), 223\u2013250."
  },
  {
    id: 15,
    category: "Benessere emotivo",
    text: "Le emozioni negative sono informazioni, non nemici: ascoltale con curiosit\u00e0.",
    reference: "Gross, J. J. (2002). Emotion regulation: Affective, cognitive, and social consequences. Psychophysiology, 39(3), 281\u2013291."
  },
  {
    id: 16,
    category: "Benessere emotivo",
    text: "Dedica 10 minuti al giorno a un\u2019attivit\u00e0 che ti d\u00e0 piacere: protegge dal burnout.",
    reference: "Sonnentag, S. (2012). Psychological detachment from work during leisure time: The benefits of mentally disengaging from work. Current Directions in Psychological Science, 21(2), 114\u2013118."
  },

  // ===== ABITUDINI =====
  {
    id: 17,
    category: "Abitudini",
    text: "Collega una nuova abitudine a una gi\u00e0 consolidata (habit stacking).",
    reference: "Fogg, B. J. (2019). Tiny Habits: The Small Changes That Change Everything. Houghton Mifflin Harcourt."
  },
  {
    id: 18,
    category: "Abitudini",
    text: "Non puntare alla perfezione: anche un\u2019azione minima conta.",
    reference: "Fogg, B. J. (2019). Tiny Habits: The Small Changes That Change Everything. Houghton Mifflin Harcourt."
  },
  {
    id: 19,
    category: "Abitudini",
    text: "Dopo 66 giorni in media, un comportamento diventa automatico.",
    reference: "Lally, P., van Jaarsveld, C. H. M., Potts, H. W. W., & Wardle, J. (2010). How are habits formed: Modelling habit formation in the real world. European Journal of Social Psychology, 40(6), 998\u20131009."
  },
  {
    id: 20,
    category: "Abitudini",
    text: "Festeggia i piccoli successi: il rinforzo positivo rafforza le abitudini.",
    reference: "Fogg, B. J. (2019). Tiny Habits: The Small Changes That Change Everything. Houghton Mifflin Harcourt."
  },
  {
    id: 21,
    category: "Abitudini",
    text: "Se salti un giorno, riprendi subito: una pausa non cancella i progressi.",
    reference: "Lally, P., van Jaarsveld, C. H. M., Potts, H. W. W., & Wardle, J. (2010). How are habits formed: Modelling habit formation in the real world. European Journal of Social Psychology, 40(6), 998\u20131009."
  },
  {
    id: 22,
    category: "Abitudini",
    text: "Cambia l\u2019ambiente per facilitare le buone abitudini: rendi visibile ci\u00f2 che vuoi fare.",
    reference: "Wood, W., & Neal, D. T. (2007). A new look at habits and the habit\u2013goal interface. Psychological Review, 114(4), 843\u2013863."
  },
  {
    id: 23,
    category: "Abitudini",
    text: "Tracciare i progressi aumenta la probabilit\u00e0 di mantenere un\u2019abitudine.",
    reference: "Harkin, B., Webb, T. L., Chang, B. P. I., Prestwich, A., Conner, M., Kellar, I., ... & Sheeran, P. (2016). Does monitoring goal progress promote goal attainment? A meta-analysis of the experimental evidence. Psychological Bulletin, 142(2), 198\u2013229."
  },

  // ===== RELAZIONI E BISOGNI =====
  {
    id: 24,
    category: "Relazioni",
    text: "Chiedi \u201cCome stai davvero?\u201d a qualcuno oggi.",
    reference: "Epley, N., & Schroeder, J. (2014). Mistakenly seeking solitude. Journal of Experimental Psychology: General, 143(5), 1980\u20131999."
  },
  {
    id: 25,
    category: "Relazioni",
    text: "Esprimi gratitudine verso qualcuno: rafforza la relazione e il tuo umore.",
    reference: "Algoe, S. B., Haidt, J., & Gable, S. L. (2008). Beyond reciprocity: Gratitude and relationships in everyday life. Emotion, 8(3), 425\u2013429."
  },
  {
    id: 26,
    category: "Relazioni",
    text: "Ascoltare attivamente \u00e8 una delle forme pi\u00f9 potenti di cura.",
    reference: "Rogers, C. R. (1951). Client-Centered Therapy: Its Current Practice, Implications and Theory. Houghton Mifflin."
  },
  {
    id: 27,
    category: "Relazioni",
    text: "Dire no a qualcosa significa dire s\u00ec a qualcos\u2019altro.",
    reference: "Alberti, R. E., & Emmons, M. L. (1970). Your Perfect Right: A Guide to Assertive Behavior. Impact Publishers."
  },
  {
    id: 28,
    category: "Relazioni",
    text: "I bisogni insoddisfatti generano emozioni intense: ascoltali.",
    reference: "Deci, E. L., & Ryan, R. M. (2000). The \u2018what\u2019 and \u2018why\u2019 of goal pursuits: Human needs and the self-determination of behavior. Psychological Inquiry, 11(4), 227\u2013268."
  },
  {
    id: 29,
    category: "Relazioni",
    text: "Coltiva almeno una relazione profonda: \u00e8 il miglior predittore di felicit\u00e0.",
    reference: "Waldinger, R. J., & Schulz, M. S. (2023). The Good Life: Lessons from the World\u2019s Longest Scientific Study of Happiness. Simon & Schuster."
  },
  {
    id: 30,
    category: "Relazioni",
    text: "Il contatto fisico (un abbraccio, una stretta di mano) rilascia ossitocina e riduce lo stress.",
    reference: "Uvn\u00e4s-Moberg, K., Handlin, L., & Petersson, M. (2015). Self-soothing behaviors with particular reference to oxytocin release induced by non-noxious sensory stimulation. Frontiers in Psychology, 5, 1529."
  },

  // ===== GESTIONE ECONOMICA =====
  {
    id: 31,
    category: "Gestione economica",
    text: "Tracciare le spese riduce la spesa impulsiva fino al 15%.",
    reference: "Prelec, D., & Loewenstein, G. (1998). The red and the black: Mental accounting of savings and debt. Marketing Science, 17(1), 4\u201328."
  },
  {
    id: 32,
    category: "Gestione economica",
    text: "Aspetta 24 ore prima di un acquisto non programmato.",
    reference: "Ariely, D. (2008). Predictably Irrational: The Hidden Forces That Shape Our Decisions. Harper Collins."
  },
  {
    id: 33,
    category: "Gestione economica",
    text: "Distingui bisogni da desideri: \u00e8 la base di ogni budget consapevole.",
    reference: "Kahneman, D., & Tversky, A. (1979). Prospect theory: An analysis of decision under risk. Econometrica, 47(2), 263\u2013291."
  },
  {
    id: 34,
    category: "Gestione economica",
    text: "Paga in contanti quando possibile: il pagamento fisico rende pi\u00f9 consapevoli della spesa.",
    reference: "Raghubir, P., & Srivastava, J. (2008). Monopoly money: The effect of payment coupling and form on spending behavior. Journal of Experimental Psychology: Applied, 14(3), 213\u2013225."
  },
  {
    id: 35,
    category: "Gestione economica",
    text: "Automatizza il risparmio: le decisioni automatiche riducono la fatica decisionale.",
    reference: "Thaler, R. H., & Benartzi, S. (2004). Save More Tomorrow\u2122: Using behavioral economics to increase employee saving. Journal of Political Economy, 112(S1), S164\u2013S187."
  },

  // ===== AUTOCURA E CORPO =====
  {
    id: 36,
    category: "Autocura",
    text: "20 minuti di camminata migliorano l\u2019umore per le successive 12 ore.",
    reference: "Edwards, M. K., & Loprinzi, P. D. (2018). Experimental effects of brief, single bouts of walking and meditation on mood profile in young adults. Health Promotion Perspectives, 8(3), 171\u2013178."
  },
  {
    id: 37,
    category: "Autocura",
    text: "Dormire 7-9 ore non \u00e8 un lusso: \u00e8 manutenzione del cervello.",
    reference: "Walker, M. (2017). Why We Sleep: Unlocking the Power of Sleep and Dreams. Scribner."
  },
  {
    id: 38,
    category: "Autocura",
    text: "L\u2019esposizione alla luce naturale al mattino regola il ritmo circadiano.",
    reference: "Wehr, T. A., Aeschbach, D., & Duncan, W. C. (2001). Evidence for a biological dawn and dusk in the human circadian timing system. The Journal of Physiology, 535(3), 937\u2013951."
  },
  {
    id: 39,
    category: "Autocura",
    text: "Bere acqua a sufficienza migliora concentrazione e umore.",
    reference: "Ganio, M. S., Armstrong, L. E., Casa, D. J., McDermott, B. P., Lee, E. C., Yamamoto, L. M., ... & Lieberman, H. R. (2011). Mild dehydration impairs cognitive performance and mood of men. British Journal of Nutrition, 106(10), 1535\u20131543."
  },
  {
    id: 40,
    category: "Autocura",
    text: "Lo stretching riduce la tensione muscolare e l\u2019ansia percepita.",
    reference: "Berger, B. G., & Owen, D. R. (1988). Stress reduction and mood enhancement in four exercise modes: Swimming, body conditioning, hatha yoga, and fencing. Research Quarterly for Exercise and Sport, 59(2), 148\u2013159."
  },
  {
    id: 41,
    category: "Autocura",
    text: "Mangiare lentamente migliora la digestione e la saziet\u00e0.",
    reference: "Andrade, A. M., Greene, G. W., & Melanson, K. J. (2008). Eating slowly led to decreases in energy intake within meals in healthy women. Journal of the American Dietetic Association, 108(7), 1186\u20131191."
  },

  // ===== SCRITTURA E RIFLESSIONE =====
  {
    id: 42,
    category: "Scrittura",
    text: "Scrivere i propri pensieri riduce lo stress e migliora la salute.",
    reference: "Pennebaker, J. W. (1997). Writing about emotional experiences as a therapeutic process. Psychological Science, 8(3), 162\u2013166."
  },
  {
    id: 43,
    category: "Scrittura",
    text: "Rileggere il diario ti aiuta a riconoscere pattern ricorrenti nella tua vita.",
    reference: "Wilson, T. D. (2002). Strangers to Ourselves: Discovering the Adaptive Unconscious. Harvard University Press."
  },
  {
    id: 44,
    category: "Scrittura",
    text: "La riflessione serale consolida gli apprendimenti della giornata.",
    reference: "Di Stefano, G., Gino, F., Pisano, G. P., & Staats, B. R. (2016). Making experience count: The role of reflection in individual learning. Harvard Business School NOM Unit Working Paper, 14-093."
  },
  {
    id: 45,
    category: "Scrittura",
    text: "Scrivere a mano attiva aree cerebrali diverse dalla digitazione: alterna i metodi.",
    reference: "Mueller, P. A., & Oppenheimer, D. M. (2014). The pen is mightier than the keyboard: Advantages of longhand over laptop note taking. Psychological Science, 25(6), 1159\u20131168."
  },
  {
    id: 46,
    category: "Scrittura",
    text: "Descrivere un problema per iscritto aiuta a trovare soluzioni pi\u00f9 creative.",
    reference: "Klein, G. (2007). Performing a project premortem. Harvard Business Review, 85(9), 18\u201319."
  },

  // ===== GESTIONE DELLO STRESS =====
  {
    id: 47,
    category: "Gestione dello stress",
    text: "Lo stress moderato migliora le prestazioni: il problema \u00e8 lo stress cronico.",
    reference: "Yerkes, R. M., & Dodson, J. D. (1908). The relation of strength of stimulus to rapidity of habit-formation. Journal of Comparative Neurology and Psychology, 18(5), 459\u2013482."
  },
  {
    id: 48,
    category: "Gestione dello stress",
    text: "Trascorri almeno 20 minuti nella natura: riduce il cortisolo in modo misurabile.",
    reference: "Hunter, M. R., Gillespie, B. W., & Chen, S. Y. (2019). Urban nature experiences reduce stress in the context of daily life based on salivary biomarkers. Frontiers in Psychology, 10, 722."
  },
  {
    id: 49,
    category: "Gestione dello stress",
    text: "Identifica ci\u00f2 che puoi controllare e lascia andare il resto.",
    reference: "Beck, A. T. (1979). Cognitive Therapy and the Emotional Disorders. Penguin Books."
  },
  {
    id: 50,
    category: "Gestione dello stress",
    text: "Il perfezionismo \u00e8 un fattore di rischio per ansia e depressione: punta al \u2018sufficientemente buono\u2019.",
    reference: "Egan, S. J., Wade, T. D., & Shafran, R. (2011). Perfectionism as a transdiagnostic process: A clinical review. Clinical Psychology Review, 31(2), 203\u2013212."
  },
  {
    id: 51,
    category: "Gestione dello stress",
    text: "Ridi ogni giorno: l\u2019umorismo riduce il cortisolo e aumenta le endorfine.",
    reference: "Berk, L. S., Felten, D. L., Tan, S. A., Bittman, B. B., & Westengard, J. (2001). Modulation of neuroimmune parameters during the eustress of humor-associated mirthful laughter. Alternative Therapies in Health and Medicine, 7(2), 62\u201376."
  },
  {
    id: 52,
    category: "Gestione dello stress",
    text: "Pratica il grounding: concentrati su 5 cose che vedi, 4 che tocchi, 3 che senti, 2 che annusi, 1 che gusti.",
    reference: "van der Kolk, B. (2014). The Body Keeps the Score: Brain, Mind, and Body in the Healing of Trauma. Viking."
  },

  // ===== MOTIVAZIONE E AUTOEFFICACIA =====
  {
    id: 53,
    category: "Motivazione",
    text: "Visualizza il processo, non solo il risultato: chi immagina i passi concreti ha pi\u00f9 successo.",
    reference: "Taylor, S. E., Pham, L. B., Rivkin, I. D., & Armor, D. A. (1998). Harnessing the imagination: Mental simulation, self-regulation, and coping. American Psychologist, 53(4), 429\u2013439."
  },
  {
    id: 54,
    category: "Motivazione",
    text: "Confrontati con te stesso di ieri, non con gli altri di oggi.",
    reference: "Festinger, L. (1954). A theory of social comparison processes. Human Relations, 7(2), 117\u2013140."
  },
  {
    id: 55,
    category: "Motivazione",
    text: "Credere di poter migliorare (growth mindset) \u00e8 il primo passo per farlo.",
    reference: "Dweck, C. S. (2006). Mindset: The New Psychology of Success. Random House."
  },
  {
    id: 56,
    category: "Motivazione",
    text: "Ogni errore \u00e8 un dato: analizzalo senza giudicarti.",
    reference: "Dweck, C. S. (2006). Mindset: The New Psychology of Success. Random House."
  },
  {
    id: 57,
    category: "Motivazione",
    text: "La motivazione intrinseca (fare qualcosa perch\u00e9 ti piace) \u00e8 pi\u00f9 duratura di quella estrinseca.",
    reference: "Deci, E. L., & Ryan, R. M. (1985). Intrinsic Motivation and Self-Determination in Human Behavior. Springer."
  },

  // ===== SONNO E RECUPERO =====
  {
    id: 58,
    category: "Sonno",
    text: "Evita gli schermi 30 minuti prima di dormire: la luce blu inibisce la melatonina.",
    reference: "Chang, A. M., Aeschbach, D., Duffy, J. F., & Czeisler, C. A. (2015). Evening use of light-emitting eReaders negatively affects sleep, circadian timing, and next-morning alertness. Proceedings of the National Academy of Sciences, 112(4), 1232\u20131237."
  },
  {
    id: 59,
    category: "Sonno",
    text: "Una routine serale costante migliora la qualit\u00e0 del sonno.",
    reference: "Irish, L. A., Kline, C. E., Gunn, H. E., Buysse, D. J., & Hall, M. H. (2015). The role of sleep hygiene in promoting public health: A review of empirical evidence. Sleep Medicine Reviews, 22, 23\u201336."
  },
  {
    id: 60,
    category: "Sonno",
    text: "Il riposo non \u00e8 ozio: \u00e8 necessario per la creativit\u00e0 e il problem-solving.",
    reference: "Immordino-Yang, M. H., Christodoulou, J. A., & Singh, V. (2012). Rest is not idleness: Implications of the brain\u2019s default mode for human development and education. Perspectives on Psychological Science, 7(4), 352\u2013364."
  },
];

/**
 * Restituisce il suggerimento del giorno basato sulla data.
 * Usa il giorno dell'anno per ciclare i suggerimenti senza ripetizioni per ~2 mesi.
 */
export function getTipOfTheDay(date = new Date()) {
  const startOfYear = new Date(date.getFullYear(), 0, 0);
  const diff = date - startOfYear;
  const dayOfYear = Math.floor(diff / (1000 * 60 * 60 * 24));
  const index = dayOfYear % DAILY_TIPS.length;
  return DAILY_TIPS[index];
}

/**
 * Restituisce un suggerimento casuale.
 * Pensato per cambiare ad ogni mount/refresh (ogni accesso all'app),
 * non vincolato al giorno solare.
 */
export function getRandomTip() {
  const index = Math.floor(Math.random() * DAILY_TIPS.length);
  return DAILY_TIPS[index];
}

export default DAILY_TIPS;
